// เสียงแจ้งเตือน (สร้างด้วย Web Audio API — ไม่ต้องใช้ไฟล์เสียงภายนอก)
// คล้ายเสียง "ติ้ง" ของ Facebook Messenger เวลามีข้อความ/แจ้งเตือนเข้า

let ctx = null;

function getCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  return ctx;
}

// เบราว์เซอร์บล็อกเสียงจนกว่าผู้ใช้จะโต้ตอบกับหน้าเว็บก่อน 1 ครั้ง
// เลยดัก event แรกไว้ปลดล็อก AudioContext ล่วงหน้า
function unlock() {
  const c = getCtx();
  if (c && c.state === "suspended") c.resume().catch(() => {});
}
if (typeof document !== "undefined") {
  ["click", "keydown", "touchstart"].forEach((evt) =>
    document.addEventListener(evt, unlock, { once: true, passive: true })
  );
}

export function playNotifSound() {
  try {
    const c = getCtx();
    if (!c) return;
    if (c.state === "suspended") c.resume().catch(() => {});

    const now = c.currentTime;
    // สองโน้ตไล่เสียงสูงขึ้น ให้ความรู้สึกคล้าย "ติ้งเด้ง" ของ Messenger
    const notes = [
      { freq: 988,  start: 0,    dur: 0.14 },
      { freq: 1319, start: 0.09, dur: 0.22 },
    ];
    notes.forEach(({ freq, start, dur }) => {
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0, now + start);
      gain.gain.linearRampToValueAtTime(0.22, now + start + 0.012);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + start + dur);
      osc.connect(gain).connect(c.destination);
      osc.start(now + start);
      osc.stop(now + start + dur + 0.03);
    });
  } catch (_) {}
}
